// extracted by mini-css-extract-plugin
module.exports = {"CategoryOverview":"CategoryOverview_CategoryOverview__VEEk7","CategoryList":"CategoryOverview_CategoryList__s9B7c"};